import * as core from '../../../../../../../core'
import * as anomaly from '../anomaly'

export const RESOURCE = {
  payload: {
    description: 'Number on Door is Incorrect',
    enumId: core.dms.models.Enum.Id.from({
      partialId: anomaly.RESOURCE.payload.partialId,
    }),
    id: 'INCORRECT_DOOR_NUMBER',
    name: 'Incorrect Door Number',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
